import { motion } from "framer-motion";
import type { CSSProperties } from "react";

interface RobotEyesProps {
  cursor: {
    x: number;
    y: number;
  };
  passwordFocused: boolean;
  buttonHovered: boolean;
  loginSuccess: boolean;
}

export const RobotEyes = ({
  cursor,
  passwordFocused,
  buttonHovered,
  loginSuccess,
}: RobotEyesProps) => {
  const lookX = (cursor.x - 0.5) * 24;
  const lookY = (cursor.y - 0.5) * 18 + (passwordFocused ? 4 : 0);
  const lidOffset = passwordFocused ? 0.34 : 0.08;
  const pupilScale = loginSuccess ? 1.08 : 1;
  const glow = buttonHovered ? 1 : 0.72;

  return (
    <div className={`robot-eyes ${passwordFocused ? "is-focused" : ""}`}>
      <motion.span
        className="robot-eye robot-eye-left"
        style={
          {
            "--pupil-x": `${lookX}px`,
            "--pupil-y": `${lookY}px`,
            "--eye-lid": lidOffset,
            "--eye-glow": glow,
          } as CSSProperties
        }
        animate={
          loginSuccess
            ? {
                y: [0, 2, 0],
                transition: { duration: 0.55, ease: "easeOut" },
              }
            : undefined
        }
      >
        <span className="robot-eye-shell">
          <span className="robot-eye-flare" />
          <span className="robot-pupil-track">
            <motion.span
              className="robot-pupil"
              animate={{
                scale: passwordFocused ? 0.92 : pupilScale,
                x: lookX,
                y: lookY,
              }}
              transition={{ type: "spring", stiffness: 76, damping: 13 }}
            />
          </span>
          <motion.span
            className="robot-eye-lid robot-eye-lid-top"
            animate={{
              scaleY: passwordFocused ? 1 : 0.16,
            }}
            transition={{ type: "spring", stiffness: 200, damping: 18 }}
          />
        </span>
      </motion.span>

      <motion.span
        className="robot-eye robot-eye-right"
        style={
          {
            "--pupil-x": `${lookX}px`,
            "--pupil-y": `${lookY}px`,
            "--eye-lid": lidOffset,
            "--eye-glow": glow,
          } as CSSProperties
        }
        animate={
          loginSuccess
            ? {
                y: [0, 2, 0],
                transition: { duration: 0.55, ease: "easeOut", delay: 0.04 },
              }
            : undefined
        }
      >
        <span className="robot-eye-shell">
          <span className="robot-eye-flare" />
          <span className="robot-pupil-track">
            <motion.span
              className="robot-pupil"
              animate={{
                scale: passwordFocused ? 0.92 : pupilScale,
                x: lookX,
                y: lookY,
              }}
              transition={{ type: "spring", stiffness: 76, damping: 13 }}
            />
          </span>
          <motion.span
            className="robot-eye-lid robot-eye-lid-top"
            animate={{
              scaleY: passwordFocused ? 1 : 0.16,
            }}
            transition={{ type: "spring", stiffness: 200, damping: 18 }}
          />
        </span>
      </motion.span>
    </div>
  );
};
